import request from '@/utils/axios.tool';
// 周节点列表
export const lists = (data) => {
    return request.post(`/roleapi/TaskMakeNote/lists`, data)
  }
//   周节点设置(添加和修改)
  export const save = (data) => {
    return request.post(`/roleapi/TaskMakeNote/save`, data)
  }